import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tappearance: none;\n\tborder: none;\n\tmargin: 0;\n\tpadding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * External dependencies
 */
import { css } from '@wp-g2/styles';
export var FontSizeControl = css(_templateObject());
//# sourceMappingURL=styles.js.map